class IsIos {
    constructor() {
        this.isIos();
    }

    isIos() {
        if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
            document.body.classList.add("is-ios");
        }
    }
}

export default IsIos;